<div class="header-wrapper">    
    <div class="header">
        <img class="logo" src="assets/images/logo.png" alt="logo">
        <div class="logo-wrapper">
        <div class="logo-title ">
            <div class="nume-cabinet">
                {{Nume_Cabinet}}
            </div>
            <div class="nume-wrapper">
                <div class="nume">
                    {{Nume1}}
                </div>
                <div class="nume">
                    {{Nume2}}
                </div>
            </div>
        </div>
        </div>
        <div class="header-menu-group">
          <nav class="header-menu">
              <a routerLink="/" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }">{{Acasa_menu}}</a>
              <a routerLink="/psihoterapy" routerLinkActive="selected">{{DespreNoi_menu}}</a>
              <a routerLink="/library" routerLinkActive="selected">{{Cursuri_menu}}</a>
              <a routerLink="/send-message" routerLinkActive="selected">{{Contact_menu}}</a>
          </nav>
          <a class="shared-primary-button header-cta" routerLink="/send-message">Programează-te</a>
        </div>
        <div class="burger" (click)="toggleMenu()">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
    
</div> 

<div class="overlay" 
     [class.show]="isMenuOpen"
     (click)="closeMenu()">
</div>

<!-- Side Drawer -->
<nav class="side-drawer" [class.open]="isMenuOpen" (click)="closeMenu()">
  <a routerLink="/" (click)="closeMenu()">{{Acasa_menu}}</a>
  <a routerLink="/psihoterapy" (click)="closeMenu()">{{DespreNoi_menu}}</a>
  <a routerLink="/library" (click)="closeMenu()">{{Cursuri_menu}}</a>
  <a routerLink="/send-message" class="shared-primary-button side-drawer-cta" (click)="closeMenu()">Programează-te</a>
</nav>


<nav class="mobile-menu" [class.open]='isMenuOpen'>
  
</nav>
<div class="header-separator "></div>


